import NotFoundPage from '../views/NotFoundPage';

export default [
  {
    path: '*',
    component: NotFoundPage,
  },
];
